import React, {FC, useEffect, useRef, useState} from "react"
import {CommentNoteSection} from "../Sections/CommentNoteSection"
import moment from "moment"
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils"
import {SummarySection} from "../Sections/SummarySection"
import EditorAddEditNoteForm from "../../modal/EditorAddEditNoteForm"
import {
    calculateCurrentWithExemptionEstimateValue,
    calculateCurrentWoExemptAmountValue,
    getUserFriendlyTaxDataSource,
    jsonCloneWithDates,
    lowerCaseAllWordsExceptFirstLetters,
    recalculateAssessment,
    upperCaseFirstLetter
} from "../../../../helpers/utils/OrderDetailUtils"
import {PropertyInfoSection} from "../Sections/PropertyInfoSection";
import AssessmentInfoSection from "../Sections/AssessmentInfoSection"


interface props {

    certificate: any,
    showAccount: number,
    orderData: any,
    setCertificate: any,
    deleteNote: any
    editable?: any
    customerId?: any;
    primaryCollector?: any
    isSavedResult?: any
    setIsSavedResult?: any
    countyData?: any,
    setAccounts?: any,
    accounts?: any,
    setUpdatedAccountIndexList?: any,
    addParentAccountsForSubdivision?: any,
    setSubdivisionId?: any
}

const AccountInformation: FC<props> = ({
                                           certificate,
                                           countyData,
                                           isSavedResult,
                                           setIsSavedResult,
                                           setUpdatedAccountIndexList,
                                           setAccounts,
                                           accounts,
                                           orderData,
                                           showAccount = 0,
                                           setCertificate,
                                           deleteNote,
                                           editable,
                                           customerId,
                                           primaryCollector,
                                           addParentAccountsForSubdivision,
                                           setSubdivisionId
                                       }) => {

    const [isCollapsed, setIsCollapsed] = useState(true);

    const [similarAccountList, setSimilarAccountList] = useState([]);
    const [name, setName] = useState(null);
    const [productTypeInvisible, setProductTypeInvisible] = useState(null);
    const [showAddCommentModal, setShowAddCommentModal] = useState(false);
    const [showUpdateCommentModal, setShowUpdateCommentModal] = useState(false);
    const [noteIndex, setNoteIndex] = useState(0);
    const [render, setRender] = useState<any>("");

    const textAreaRef = useRef<HTMLTextAreaElement>(null);


    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const [expandTagsFirstCheck, setExpandTagsChecks] = useState(false);

    useEffect(() => {
        if (textAreaRef !== null && textAreaRef.current && !expandTagsFirstCheck) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
            setExpandTagsChecks(true);
        }
    });

    useEffect(() => {
        if (
            name &&
            ["landMarketValue", "improvementMarketValue", "taxYear", "homesteadCapValue"].includes(name)
        ) {
            const account = certificate.accounts?.[showAccount];
            const assessments = account?.assessments;
            if (!account || !assessments || assessments.length < 2) return;
            const [assessment0, assessment1] = assessments;
            let updatedCert = jsonCloneWithDates(certificate);
            recalculateAssessment(showAccount, setRender, updatedCert, setCertificate);
            calculateCurrentWoExemptAmountValue(updatedCert, showAccount, assessment0, setRender, setCertificate);
            calculateCurrentWoExemptAmountValue(updatedCert, showAccount, assessment1, setRender, setCertificate);
            calculateCurrentWithExemptionEstimateValue(updatedCert, showAccount, assessment0, setRender, setCertificate);
            calculateCurrentWithExemptionEstimateValue(updatedCert, showAccount, assessment1, setRender, setCertificate);

            setUpdatedAccountIndexList((prev: number[]) =>
                prev.includes(showAccount) ? prev : [...prev, showAccount]
            );
            // @ts-ignore
            setName("");
        }
    }, [name]);

    return (
        <>

            {certificate &&
                <div className="bg-text-1 rounded-t-[7px] shadow-md  pt-2 mt-3 col-span-12 grid grid-cols-12 w-full">
                    <div className="flex items-center justify-between col-span-12 px-2 py-2">
                        <h5 className="text-lg font-semibold"
                            title={certificate?.accounts[showAccount]?.asOfDate !== null && certificate?.accounts[showAccount]?.asOfDate !== '' ? moment(certificate?.accounts[showAccount]?.asOfDate).format("MM/DD/YYYY") : "-"}>
                            Account Information
                            - {orderData?.data?.collectorAppraisalDistrictLink?.url ?
                            <a className={"cursor text-highlight-4"}
                               href={orderData?.data?.collectorAppraisalDistrictLink?.url}
                               target={"_blank"}>
                                {orderData?.data?.county}
                            </a>
                            :
                            (hasPermission(["COLLINK-C"]) === true ?
                                    <a className={"cursor text-highlight-4"}
                                       onClick={() => {
                                           localStorage.setItem("collectorObj", JSON.stringify(primaryCollector));
                                           localStorage.setItem("collectorLinkType", 'APPRAISAL_DISTRICT');
                                       }}
                                       href={'/collector-links/create'}
                                       target={"_blank"}>{orderData?.data?.county}
                                    </a> : orderData?.data?.county
                            )
                        }


                            {(certificate.accounts[showAccount]?.taxDataSource !== null && certificate.accounts[showAccount]?.taxDataSource !== '') ? ' (Source : ' + upperCaseFirstLetter(lowerCaseAllWordsExceptFirstLetters(getUserFriendlyTaxDataSource(certificate?.accounts[showAccount]?.taxDataSource))) + ')' : ''}
                        </h5>
                        <div className="ml-auto">
                            <button
                                className="text-highlight-5 focus:outline-none"
                                onClick={toggleCollapse}
                            >
                                <i
                                    className={`fa fa-angle-right transition-transform duration-300 ${isCollapsed ? "rotate-90" : ""
                                    }`}
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                    </div>
                    {isCollapsed && (
                        <div id={'accountInfo' + showAccount} className="col-span-12 py-2 px-2">
                            <hr/>


                            <div className="grid grid-cols-1 md:grid-cols-2 w-full border border-highlight-5">
                                <div className="w-full">
                                    <PropertyInfoSection curAccount={certificate.accounts[showAccount]}
                                                         setIsSavedResult={setIsSavedResult}
                                                         accounts={accounts}
                                                         setAccounts={setAccounts}
                                                         certificate={certificate}
                                                         setCertificate={setCertificate}
                                                         showAccount={showAccount}
                                                         similarAccountList={similarAccountList}
                                                         setSimilarAccountList={setSimilarAccountList}
                                                         order={orderData?.data && orderData?.data}
                                                         editable={editable}
                                                         setRender={setRender}
                                                         addParentAccountsForSubdivision={addParentAccountsForSubdivision}
                                                         setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                         countyData={countyData}
                                                         setSubdivisionId={setSubdivisionId}
                                    />
                                </div>
                                <div className="w-full">
                                    <AssessmentInfoSection curAccount={certificate.accounts[showAccount]}
                                                           certificate={certificate}
                                                           setCertificate={setCertificate}
                                                           setName={setName}
                                                           setIsSavedResult={setIsSavedResult}
                                                           accounts={accounts}
                                                           setAccounts={setAccounts}
                                                           editable={editable}
                                                           setProductTypeInvisible={setProductTypeInvisible}
                                                           setRender={setRender}
                                                           setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                           showAccount={showAccount}
                                                           customerId={customerId}

                                    />
                                </div>
                            </div>

                            <div className="col-lg-12 col-sm-12 mt-3 mb-3 border border-highlight-3">
                                <div
                                    className="p-1 border border-highlight-3 bg-highlight-3 text-text-0 flex justify-between">
                                    <b>Legal Description {editable}</b>
                                </div>

                                <div className="assessment_info">
                                    <textarea className="w-full rounded-none overflow-hidden bg-text-0 p-4"
                                              name="legalDescription" ref={textAreaRef}
                                              placeholder="..."
                                              value={certificate.accounts[showAccount]?.legalDescription}
                                              onInput={() => {
                                                  if (textAreaRef.current) {
                                                      textAreaRef.current.style.height = 'auto';
                                                      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
                                                  }
                                              }}
                                              onChange={(e) => {
                                                  if (editable) {
                                                      certificate.accounts[showAccount].legalDescription = e.target.value;
                                                      setIsSavedResult(false);
                                                      setAccounts([...accounts]);
                                                      setUpdatedAccountIndexList((prev: number[]) =>
                                                          prev.includes(showAccount) ? prev : [...prev, showAccount]
                                                      );
                                                  }
                                              }}

                                              readOnly={!editable}
                                    />
                                </div>
                            </div>

                            <CommentNoteSection
                                type={"Account Comments"}
                                curAccount={certificate.accounts[showAccount]?.accountNotes}
                                certificate={certificate}
                                setCertificate={setCertificate}
                                orderId={orderData?.data?.id}
                                showAccount={showAccount}
                                setIsSavedResult={setIsSavedResult}
                                deleteNote={deleteNote}
                                editable={editable}
                                setShowAdd={setShowAddCommentModal}
                                setShowUpdate={setShowUpdateCommentModal}
                                noteType={"accounts"}
                                length={certificate.accounts[showAccount]?.accountNotes + 1}
                                setIndex={setNoteIndex}
                            />

                            <SummarySection curAccount={certificate?.accounts[showAccount]}
                                            setIsSavedResult={setIsSavedResult}
                                            accounts={accounts}
                                            setAccounts={setAccounts}
                                            editable={editable}
                                            showAccount={showAccount}
                                            setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                            />
                        </div>
                    )}


                    {showAddCommentModal &&
                        <EditorAddEditNoteForm title={"Add Account Comment"} show={showAddCommentModal}
                                               setShow={setShowAddCommentModal}
                                               index={null}
                                               certificate={certificate} setCertificate={setCertificate}
                                               orderId={orderData?.data?.id}
                                               showAccount={showAccount}
                                               setIsSavedResult={setIsSavedResult}
                                               length={certificate.accounts[showAccount]?.accountNotes.length + 1}
                                               setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                        />}

                    {showUpdateCommentModal &&
                        <EditorAddEditNoteForm title={"Update Account Comment"} show={showUpdateCommentModal}
                                               setShow={setShowUpdateCommentModal}
                                               index={noteIndex}
                                               certificate={certificate}
                                               setCertificate={setCertificate} orderId={orderData?.data?.id}
                                               showAccount={showAccount}
                                               setIsSavedResult={setIsSavedResult}
                                               setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                        />}

                </div>
            }
        </>
    )


}
export default AccountInformation

